import { IAutoMapper } from "../interfaces";

export const mapMemberChartM360Response = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "MemberChartM360Response")
    .forMember("chartMetadatas", o => automapper.mapMany("default", "MemberChartItem", o.chartMetadatas))
    .forMember("paginationToken", o => o.paginationToken);
};
